import { render, staticRenderFns } from "./starMember.vue?vue&type=template&id=0daf4e25&scoped=true"
import script from "./starMember.vue?vue&type=script&lang=js"
export * from "./starMember.vue?vue&type=script&lang=js"
import style0 from "./starMember.vue?vue&type=style&index=0&id=0daf4e25&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daf4e25",
  null
  
)

export default component.exports